import { queryOptions } from '@tanstack/react-query';

import { shortCacheOptions } from '@platform/core/state';

import { getElocApiClient } from '../eloc-api-client';

const getOrganizationQueryKey = (organizationId: string) => [
  organizationId,
  'eloc',
  'get-rendall-url',
];

export const organizationQuery = (organizationId: string) =>
  queryOptions({
    queryFn: async () => {
      const client = await getElocApiClient();
      return client.getRendallURL({
        organizationId,
      });
    },
    queryKey: getOrganizationQueryKey(organizationId),
    ...shortCacheOptions,
  });
